import React from 'react';
import { Outlet } from "react-router-dom"
import logo from '../img/logo.png'
import logo_blanco from '../img/Logo-versiones-08.png';
 function Layout() {
  
   return (
    <div>
      
        <div className='logo  p-2 w-full lg:w-3/6 md:grid md:grid-cols-2 '>
          <div className=' text-white text-xl p-5 text-center md:text-left'>
            <p>Prolongación Tecnológico 996</p>
            <p>Col. San Pablo</p>
            <p>Querétaro, Qro.</p>
          </div>
          <div>
            <img src={logo} width={600}/>
          </div>                      
        </div>        
        <div className='grid grid-cols-3  top-10 right-0 md:w-1/6 md:absolute content-center w-screen place-items-center'>
            <a href='https://www.facebook.com/parquemonchis?mibextid=LQQJ4d' target='_blank'>
              <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-brand-facebook" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#C6A75B" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                <path d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3" />
              </svg>
            </a>
            <a href='https://www.instagram.com/parquemonchis?igsh=MTNmdjltMXFicjg4Ng%3D%3D&utm_source=qr' target='_blank'>
              <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-brand-instagram" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#C6A75B" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                <path d="M4 4m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z" />
                <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                <path d="M16.5 7.5l0 .01" />
              </svg>
            </a>
            <a href='https://maps.app.goo.gl/XLYV74NnnZryUTeK8?g_st=ic' target='_blank'>
              <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-brand-google-maps" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#C6A75B" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                <path d="M12 9.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0" />                      
                <path d="M17.591 6.376c.472 .907 .715 1.914 .709 2.935a7.263 7.263 0 0 1 -.72 3.18a19.085 19.085 0 0 1 -2.089 3c-.784 .933 -1.49 1.93 -2.11 2.98c-.314 .62 -.568 1.27 -.757 1.938c-.121 .36 -.277 .591 -.622 .591c-.315 0 -.463 -.136 -.626 -.593a10.595 10.595 0 0 0 -.779 -1.978a18.18 18.18 0 0 0 -1.423 -2.091c-.877 -1.184 -2.179 -2.535 -2.853 -4.071a7.077 7.077 0 0 1 -.621 -2.967a6.226 6.226 0 0 1 1.476 -4.055a6.25 6.25 0 0 1 4.811 -2.245a6.462 6.462 0 0 1 1.918 .284a6.255 6.255 0 0 1 3.686 3.092z" />
              </svg>        
            </a>
        </div>
       
        <Outlet/>
        <footer>
          <div className='w-full'>
            <div className='bg-azul-obscuro w-full  mx-auto p-10'>
              <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grap-2 justify-center'>
                       
                       
                        <div className='mb-2 text-blanco text-start sm:p-5 md:p-2'>
                          <h2>Buenamoza Bistró - Restaurante al aire libre en Querétaro </h2>

                          <div className='w-1/2 grid grid-cols-3  top-10 right-0 md:relative '>
                                <a href='https://www.facebook.com/parquemonchis?mibextid=LQQJ4d' target='_blank'>
                                  <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-brand-facebook" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3" />
                                  </svg>
                                </a>
                                <a href='https://www.instagram.com/parquemonchis?igsh=MTNmdjltMXFicjg4Ng%3D%3D&utm_source=qr' target='_blank'>
                                  <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-brand-instagram" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M4 4m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z" />
                                    <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                                    <path d="M16.5 7.5l0 .01" />
                                  </svg>
                                </a>
                                <a href='https://maps.app.goo.gl/XLYV74NnnZryUTeK8?g_st=ic' target='_blank'>
                                  <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-brand-google-maps" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M12 9.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0" />                      
                                    <path d="M17.591 6.376c.472 .907 .715 1.914 .709 2.935a7.263 7.263 0 0 1 -.72 3.18a19.085 19.085 0 0 1 -2.089 3c-.784 .933 -1.49 1.93 -2.11 2.98c-.314 .62 -.568 1.27 -.757 1.938c-.121 .36 -.277 .591 -.622 .591c-.315 0 -.463 -.136 -.626 -.593a10.595 10.595 0 0 0 -.779 -1.978a18.18 18.18 0 0 0 -1.423 -2.091c-.877 -1.184 -2.179 -2.535 -2.853 -4.071a7.077 7.077 0 0 1 -.621 -2.967a6.226 6.226 0 0 1 1.476 -4.055a6.25 6.25 0 0 1 4.811 -2.245a6.462 6.462 0 0 1 1.918 .284a6.255 6.255 0 0 1 3.686 3.092z" />
                                  </svg>        
                                </a>
                            </div>

                        </div>
                        <div className='mb-5 text-blanco text-start sm:p-5 md:p-2 lg:p-20'>
                          <h2 className='pb-3'>Atmosfera agradable</h2>
                          <h2>Sumérgete en la atmósfera única de nuestro bistró, donde la arquitectura elegante y sutil se encuentra con la naturaleza.  </h2>
                        </div>
                        <div className='mb-5 text-start sm:p-5 md:p-2'>
                          <img src={logo_blanco} width={100}/>
                          {/* <h1 className='text-blanco'>&copy;Buenamoza Bistró -2024 All Rights Reserved</h1> */}
                          <h1 className='text-blanco'>&copy;<a href="https://www.codigodigital.com.mx" target="_blank" >Desarrollado por <span>Código Digital</span> </a> -2024 All Rights Reserved</h1>
                           
                        </div>

              </div>                    
            </div>
        </div>
        </footer>
        </div>
        
   )
 }
 
 export default Layout;
 